import { Grid, Box, Typography, Chip } from "@material-ui/core";
import arrow from "../../../assets/arrow.svg";
import ArrowLeft from "../../../assets/arrowLeft.svg";
import { useSelector, useDispatch } from "react-redux";
import FilterButton from "./FilterButton";
import { useState, useEffect } from "react";

export default function CompetitorsSector(props) {
  const { Sectors, filters, setFilters } = props;
  const dispatch = useDispatch();
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const innerWidth = useSelector((state) => state.innerWidth.value);
  const [leftShow, setLeftShow] = useState(false);
  const [rightShow, setRightShow] = useState(false);

  useEffect(() => {
    setRightShow(
      document.getElementById("slide")?.scrollWidth >
        document.getElementById("slide")?.offsetWidth ||
        document.getElementById("slide")?.scrollWidth > 1440
        ? true
        : false
    );
    document.getElementById("slide")?.addEventListener("scroll", () => {
      setLeftShow(
        document.getElementById("slide")?.scrollLeft > 0 ? true : false
      );
    });
  });

  return (
    <div
      style={{
        padding: isDesktopOrLaptop ? "0px" : "0px 15px 15px 11px",
      }}
    >
      {isDesktopOrLaptop ? (
        <Box
          display="flex"
          flexWrap="nowrap"
          style={{
            overflowX: "scroll",
            display: "flex",
            alignItems: "center",
            padding: "0px 0 25px 98px",
          }}
          className="invisible-scrollbar"
        >
          <Grid
            item
            xs={Sectors?.length === 0 ? 3 : 2}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Typography
              variant="subtitle1"
              style={{
                color: "#808080",
                fontSize: "16px",
                fontFamily: "Overpass",
              }}
            >
              {props.t("relavent_sectors")}
            </Typography>
            {Sectors?.length === 0 ? <div className="NONE">NONE</div> : null}
          </Grid>
          {Sectors?.length > 0 ? (
            <Grid
              item
              xs={10}
              className="invisible-scrollbar"
              id="slide"
              style={{
                overflowX: "scroll",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Chip
                variant="outlined"
                color="primary"
                label="All"
                style={{
                  height: "40px",
                  border: filters?.Sector ? "1.5px solid #808080" : "",
                  color: filters?.Sector ? "#808080" : "#f8f8f8",
                  backgroundColor: filters?.Sector ? "" : "#0040ff",
                  minWidth: "98px",
                  borderRadius: "32.5px",
                  marginRight: "25px",
                  fontSize: "14px",
                  fontWeight: 400,
                  boxSizing: "border-box",
                  fontFamily: "Overpass",
                }}
                clickable={true}
                onClick={() => {
                  let newState = { ...filters };
                  delete newState?.Sector;
                  setFilters(newState);
                }}
              />
              {Sectors
                ? Sectors.map((sector) => {
                    return (
                      <FilterButton
                        sector={sector?.Title}
                        count={sector?.count}
                        filters={filters}
                        setFilters={setFilters}
                      />
                    );
                  })
                : null}
              {rightShow ? (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    // right: (innerWidth < 1440 ? 0 : innerWidth - 1440) / 2,
                    width: "75px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="SectorOval"
                    onClick={() => {
                      document.getElementById("slide").scrollLeft =
                        document.getElementById("slide").scrollLeft + 50;
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      style={{
                        width: "45px",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        userSelect: "none",
                      }}
                    >
                      <img
                        src={arrow}
                        alt="arrow"
                        style={{
                          userSelect: "none",
                        }}
                      ></img>
                    </div>
                  </div>
                </div>
              ) : null}

              {leftShow ? (
                <div
                  style={{
                    position: "absolute",
                    left: (innerWidth < 1440 ? 0 : innerWidth - 1440) / 2 + 262,
                    width: "90px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="SectorOval"
                    onClick={() => {
                      document.getElementById("slide").scrollLeft =
                        document.getElementById("slide").scrollLeft - 50;
                    }}
                    style={{
                      cursor: "pointer",
                      marginLeft: "-54px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      style={{
                        width: "45px",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        userSelect: "none",
                      }}
                    >
                      <img
                        src={ArrowLeft}
                        alt="left"
                        style={{
                          height: "21px",
                          width: "23px",
                          userSelect: "none",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </Grid>
          ) : null}
        </Box>
      ) : (
        <>
          <Grid
            item
            xs={12}
            style={{
              marginBottom: Sectors?.length > 1 ? 0 : 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              style={{
                color: "#808080",
                fontSize: "14px",
                fontFamily: "Overpass",
              }}
            >
              {props.t("relavent_sectors")}
            </Typography>
            {Sectors?.length === 0 ? <div className="NONE">NONE</div> : null}
          </Grid>
          {Sectors?.length > 0 ? (
            <Box
              display="flex"
              flexWrap="nowrap"
              style={{
                overflowX: "scroll",
                display: "flex",
                alignItems: "center",
                padding: "15px 0 15px 0px",
              }}
              className="invisible-scrollbar"
            >
              {Sectors?.length > 0 ? (
                <Grid
                  item
                  xs={12}
                  className="invisible-scrollbar"
                  id="slide"
                  style={{
                    overflowX: "scroll",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Chip
                    variant="outlined"
                    color="primary"
                    label={props.t("all")}
                    style={{
                      height: "35px",
                      border: filters?.Sector ? "1.5px solid #808080" : "",
                      color: filters?.Sector ? "#808080" : "#f8f8f8",
                      backgroundColor: filters?.Sector ? "" : "#0040ff",
                      minWidth: "98px",
                      // backgroundColor: clicked ? "#2172AB" : null,
                      borderRadius: "32.5px",
                      marginRight: "25px",
                      fontSize: "12px",
                      fontWeight: 400,
                      boxSizing: "border-box",
                      fontFamily: "Overpass",
                    }}
                    clickable={true}
                    onClick={() => {
                      let newState = { ...filters };
                      delete newState?.Sector;
                      dispatch(setFilters(newState));
                    }}
                  />
                  {Sectors
                    ? Sectors.map((sector) => {
                        return (
                          <FilterButton
                            sector={sector?.Title}
                            count={sector?.count}
                            filters={filters}
                            setFilters={setFilters}
                          />
                        );
                      })
                    : null}
                </Grid>
              ) : null}
            </Box>
          ) : null}
        </>
      )}
      <div
        className="GreyLine"
        style={{
          marginLeft: isDesktopOrLaptop ? "98px" : "0px",
          marginRight: isDesktopOrLaptop ? "98px" : "0px",
        }}
      ></div>
    </div>
  );
}
